import clsx from "clsx";
import React from "react";
// @ts-expect-error - TypeScript complains about lack of type definitions for this module, but this is the
import Linkify from "react-linkify";
import useStore from "@/stores/index";
import loadingCircle from "@/assets/IconLoadingCircle.svg?url";
import errorCicrle from "@/assets/IconErrorCircle.svg?url";
import Avatar from "@/js/components/shared/Avatar";
import { ChatMessage } from "../types";

interface Props {
	message: ChatMessage;
	isOwner: boolean;
	resendMessage: (message: ChatMessage) => void;
	avatarColor: string;
}

const MessageItem = (props: Props): JSX.Element => {
	const handleResendMessage = () => {
		props.resendMessage(props.message);
	};

	const displayName = props.message.sender.displayName || props.message.sender.username;

	return (
		<React.Fragment>
			{props.message.renderTs && <div className="ClassroomChatMessageItem_timestamp">{props.message.renderTs}</div>}

			<div className={clsx("ClassroomChatMessageItem_container", props.isOwner && "ClassroomChatMessageItem_ownerAvatarContainer")}>
				{!props.isOwner && (
					<span className="ClassroomChatMessageItem_avatarWrapper">
						<Avatar
							overrideColorClass={`${props.isOwner ? "ClassroomChatMessageItem_avatarOwner" : ""}`}
							overrideAvatarClass={clsx("ClassroomChat_AvatarLabel", !props.message.showAvatar && "ClassroomChat_AvatarLabelHide")}
							key={props.message.sender.displayName}
							color={props.avatarColor}
							label={displayName[0]}
						/>
					</span>
				)}
				<div>
					{props.message.renderTs && !props.isOwner && <div className="ClassroomChatMessageItem_displayName">{displayName}</div>}

					<div
						className={clsx(
							"ClassroomChatMessageItem_messageContainer",
							!props.isOwner && "ClassroomChatMessageItem_messageContainerNotOwner"
						)}
					>
						<div
							className={clsx(
								"ClassroomChatMessageItem_message",
								props.isOwner && "ClassroomChatMessageItem_ownerMessage",
								props.message.isSending && "ClassroomChatMessageItem_isSending"
							)}
						>
							<Linkify
								options={{
									attributes: {
										target: "_blank",
										rel: "noopener noreferrer",
									},
								}}
							>
								{props.message.message}
							</Linkify>
						</div>
						{/* @ts-expect-error - Leaving code as it is */}
						{!useStore.getState().chat.sendMessageError && props.message.isSending && (
							<div className="ClassroomChatMessageSendingState">
								<img src={loadingCircle} alt="" />
								Sending...
							</div>
						)}
						{/* @ts-expect-error - Leaving code as it is */}
						{useStore.getState().chat.sendMessageError && props.message.isSending && (
							<div className="ClassroomChatMessageSendingState">
								<img src={errorCicrle} alt="" />
								Failed to send.{" "}
								<button type="button" className="ClassroomChatMessageSendingState_resendButton" onClick={handleResendMessage}>
									Retry?
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default MessageItem;
